import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const backfillListeningScoresV1DataSchemaDefinition = z.object({
  started: z.boolean(),
});

export const backfillListeningScoresV1DataSchema: typeof backfillListeningScoresV1DataSchemaDefinition =
  backfillListeningScoresV1DataSchemaDefinition;

export type IBackfillListeningScoresV1Data = z.infer<typeof backfillListeningScoresV1DataSchema>;

export const backfillListeningScoresV1ResponseSchema: z.ZodSchema<
  IAPI<IBackfillListeningScoresV1Data>
> = createApiResponseSchema(backfillListeningScoresV1DataSchema) as z.ZodSchema<
  IAPI<IBackfillListeningScoresV1Data>
>;

export type IBackfillListeningScoresV1Response = IAPI<IBackfillListeningScoresV1Data>;
